import React, { useMemo } from 'react';
import { useRecoilValue } from 'recoil';
import { optionsState } from '../options';
import { customPreview as Symbol_customPreview } from '../symbols';
import { isArray, isPlainObject, isMap, isSet } from '../utils/types';
import { ArrayPreview } from './ArrayPreview';
import { PlainObjectPreview } from './PlainObjectPreview';
import { SetPreview } from './SetPreview';
import { MapPreview } from './MapPreview';
export function Preview(_ref) {
  let {
    data,
    hide,
    hidePlaceholder = null
  } = _ref;
  const {
    previewOpacity
  } = useRecoilValue(optionsState);
  const vdom = useMemo(function getPreview() {
    if (data[Symbol_customPreview]) {
      return data[Symbol_customPreview]();
    } else if (isSet(data)) {
      return /*#__PURE__*/React.createElement(SetPreview, {
        data: data
      });
    } else if (isMap(data)) {
      return /*#__PURE__*/React.createElement(MapPreview, {
        data: data
      });
    } else if (isArray(data)) {
      return /*#__PURE__*/React.createElement(ArrayPreview, {
        data: data
      });
    } else if (isPlainObject(data)) {
      return /*#__PURE__*/React.createElement(PlainObjectPreview, {
        data: data
      });
    }

    return null;
  }, [data, previewOpacity]);
  return !hide ? /*#__PURE__*/React.createElement("div", {
    id: "preview-container",
    style: {
      opacity: previewOpacity
    }
  }, vdom) : hidePlaceholder;
}